export var statusToColors = {
    info: { fontColor: 'gray1', backgroundColor: 'lightGray7', fill: 'gray1' },
    success: { fontColor: 'white', backgroundColor: 'green', fill: 'white' },
    error: { fontColor: 'white', backgroundColor: 'red1', fill: 'white' },
    warning: { fontColor: 'blue2', backgroundColor: 'yellow1', fill: 'blue2' },
};
export var statusToIcon = {
    info: 'info',
    success: 'circleCheck',
    error: 'circleX',
    warning: 'circleTriangle',
};
